import { Avatar } from '@mantine/core';
// icons
import { X } from 'lucide-react';

interface BubbleProps {
    pictureUrl: string;
    bubbleText: string;
    color: string;
}

const Bubble = ({ pictureUrl, bubbleText, color }: BubbleProps) => {
    const mainColor = color || '#000000';
    return (
        <div className="flex flex-col gap-4 items-end">
            <div className="flex w-full flex-col gap-2 shadow-md rounded-lg py-6 px-4 bg-white relative">
                <div className="text-right text-gray-6 absolute top-1 right-2">
                    <X className="w-5! h-5!" />
                </div>
                <Avatar
                    bg="gray.1"
                    className="shrink-0 absolute left-1/2 -translate-x-1/2 top-0 -translate-y-1/2"
                    radius="xs"
                    size="sm"
                    src={pictureUrl}
                />
                <div className="text-sm leading-tight whitespace-pre-wrap break-all">
                    {bubbleText}
                </div>
            </div>
            <div
                className="w-10 h-10 rounded-full p-2 text-white flex items-center justify-center"
                style={{ backgroundColor: mainColor }}
            >
                <svg
                    fill="currentColor"
                    height="16"
                    viewBox="0 0 24 24"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M20.7168 4.16406C18.958 2.12988 15.0606 1.40527 12 1.40527C8.93947 1.40527 5.04202 2.12988 3.28322 4.16406C0.782221 7.05762 0.782221 14.7295 3.28322 17.6221C3.76575 18.1537 4.34253 18.5914 4.9844 18.9131C5.03156 18.9422 5.07157 18.9815 5.10149 19.0282C5.1314 19.0748 5.15046 19.1276 5.15725 19.1826L5.5215 21.3662C5.57191 21.6697 5.69761 21.9558 5.88711 22.1982C6.07661 22.4406 6.32385 22.6317 6.60624 22.7539C6.88863 22.8761 7.19714 22.9255 7.50358 22.8977C7.81001 22.8699 8.10459 22.7657 8.36037 22.5947L11.6201 20.4219C11.6731 20.3877 11.7349 20.3701 11.7979 20.3711C11.8635 20.3759 11.9294 20.3763 11.9951 20.3721C15.0987 20.3721 18.9619 19.6533 20.7168 17.6221C23.2178 14.7295 23.2178 7.05762 20.7168 4.16406ZM9.00002 12.5C9.00002 12.7652 8.89466 13.0196 8.70713 13.2071C8.51959 13.3946 8.26524 13.5 8.00002 13.5C7.7348 13.5 7.48045 13.3946 7.29291 13.2071C7.10538 13.0196 7.00002 12.7652 7.00002 12.5V8.5C7.00002 8.23479 7.10538 7.98043 7.29291 7.7929C7.48045 7.60536 7.7348 7.5 8.00002 7.5C8.26524 7.5 8.51959 7.60536 8.70713 7.7929C8.89466 7.98043 9.00002 8.23479 9.00002 8.5V12.5ZM13 14.5C13 14.7652 12.8947 15.0196 12.7071 15.2071C12.5196 15.3946 12.2652 15.5 12 15.5C11.7348 15.5 11.4805 15.3946 11.2929 15.2071C11.1054 15.0196 11 14.7652 11 14.5V6.5C11 6.23479 11.1054 5.98043 11.2929 5.7929C11.4805 5.60536 11.7348 5.5 12 5.5C12.2652 5.5 12.5196 5.60536 12.7071 5.7929C12.8947 5.98043 13 6.23479 13 6.5V14.5ZM17 12.5C17 12.7652 16.8947 13.0196 16.7071 13.2071C16.5196 13.3946 16.2652 13.5 16 13.5C15.7348 13.5 15.4805 13.3946 15.2929 13.2071C15.1054 13.0196 15 12.7652 15 12.5V8.5C15 8.23479 15.1054 7.98043 15.2929 7.7929C15.4805 7.60536 15.7348 7.5 16 7.5C16.2652 7.5 16.5196 7.60536 16.7071 7.7929C16.8947 7.98043 17 8.23479 17 8.5V12.5Z" />
                </svg>
            </div>
        </div>
    );
};

export default Bubble;
